"use client";
import { anatomy } from "@zag-js/listbox";
//#region src/components/listbox/listbox.anatomy.ts
var listboxAnatomy = anatomy.extendWith("empty");
//#endregion
export { listboxAnatomy };
